import {ApiError} from './errorHandling.types';
import {emit, emitGeneralErrorToast} from '../toasts/toasts.utils';
import {handleGeneralError} from './handleGeneralError';

function handleErrorByResponse(status: number, message: string) {
  if (status < 500) {
    emit.error({message});
  } else {
    emitGeneralErrorToast();
  }
}

function handleApiError(error: ApiError, rethrow?: boolean) {
  try {
    handleErrorByResponse(error.status, error.message);
  } catch (unhandledError) {
    handleGeneralError(error);
  }

  if (rethrow) {
    throw error;
  }
}

export {handleApiError};
